import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentCattle:[],
    loading:false,
}

const cattleSlice=createSlice({
name:'cattle',

initialState,
reducers:{
    loginStartC:(state)=>{
        state.loading=true

    },
    loginSuccessC:(state,{payload})=>{
        state.loading=false;
        state.currentCattle=payload;
        

    },
    loginFailureC:(state)=>{


    },
    logOutC:(state)=>{
        state.loading=false;
        state.currentCattle=[];

    }
    

}
})
export const {loginStartC,loginFailureC,loginSuccessC,logOutC}=cattleSlice.actions

export default cattleSlice.reducer